import React from 'react'
import { Button, Box, keyframes } from '@mui/material'
import ExploreIcon from '@mui/icons-material/TravelExplore'

// Animaciones keyframes
const pulseGlow = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(39, 154, 83, 0.6), 0 6px 20px rgba(0,0,0,0.2);
  }
  70% {
    box-shadow: 0 0 0 16px rgba(39, 154, 83, 0), 0 6px 20px rgba(0,0,0,0.2);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(39, 154, 83, 0), 0 6px 20px rgba(0,0,0,0.2);
  }
`

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`

const iconBounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  40% {
    transform: translateY(-3px) rotate(8deg);
  }
  60% {
    transform: translateY(-1px) rotate(-4deg);
  }
`

const breathe = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.01);
  }
`

// Componente de ejemplo de uso
const ButtonMain = ({ onClick, city }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        position: 'relative',
        my: 4,
      }}>
      <Button
        variant="contained"
        size="large"
        endIcon={
          <ExploreIcon
            sx={{
              fontSize: '1.4rem',
              animation: `${iconBounce} 2s ease-in-out infinite`,
              '&:hover': {
                animation: `${iconBounce} 0.6s ease-in-out infinite`,
              },
            }}
          />
        }
        onClick={onClick}
        sx={{
          position: 'relative',
          px: 5,
          py: 1.2,
          borderRadius: 50,
          fontWeight: 700,
          fontSize: '1.1rem',
          textTransform: 'none',
          background: 'linear-gradient(135deg, #279a53 0%, #93c032 50%, #279a53 100%)',
          color: '#ffffff',
          border: '2px solid rgba(255,255,255,0.15)',
          boxShadow:
            '0 6px 20px rgba(39, 154, 83, 0.4), inset 0 1px 0 rgba(255,255,255,0.2)',
          animation: `${pulseGlow} 3s infinite, ${breathe} 4s ease-in-out infinite`,
          overflow: 'hidden',

          // Efecto shimmer externo
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -4,
            left: -4,
            right: -4,
            bottom: -4,
            background: 'linear-gradient(45deg, #279a53, #93c032, #279a53, #1c7b3f)',
            backgroundSize: '300% 300%',
            borderRadius: 50,
            opacity: 0,
            transition: 'opacity 0.4s ease',
            animation: `${shimmer} 3s linear infinite`,
            zIndex: -1,
          },

          // Efecto shimmer interno
          '&::after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            background:
              'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
            transition: 'left 0.6s',
            zIndex: 1,
          },

          '&:hover': {
            background: 'linear-gradient(135deg, #93c032 0%, #279a53 50%, #1c7b3f 100%)',
            transform: 'scale(1.06)',
            boxShadow:
              '0 8px 28px rgba(39, 154, 83, 0.6), inset 0 2px 0 rgba(255,255,255,0.3)',
            animation: `${pulseGlow} 1.8s infinite, ${breathe} 2.5s ease-in-out infinite`,

            '&::before': {
              opacity: 0.9,
            },

            '&::after': {
              left: '100%',
            },
          },

          '&:active': {
            transform: 'scale(1.02)',
            boxShadow:
              '0 4px 15px rgba(39, 154, 83, 0.8), inset 0 2px 0 rgba(255,255,255,0.3)',
          },

          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

          // Efecto de texto brillante
          '& .MuiButton-label, & span': {
            position: 'relative',
            zIndex: 2,
            textShadow: '0 1px 3px rgba(12, 35, 66, 0.3)',
          },

          // Responsive
          '@media (max-width: 768px)': {
            fontSize: '1rem',
            px: 4,
            py: 1,
          },
        }}>
        Explorar en {city}
      </Button>
    </Box>
  )
}

export default ButtonMain
